import Box from 'components/shared/Box'
import styled, { css } from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import badgePlus from 'assets/icons/badge_plus.svg'
import badgeWarning from 'assets/icons/badge_warning.svg'

interface DayWrapperProps {
    hasHighlight: boolean
    hasDarkMode?: boolean
}

export const DayWrapper = styled(Box)<DayWrapperProps>`
    position: relative;
    width: 100%;
    height: 100%;
    justify-content: center;
    padding: 8px 0;
    ${({ hasHighlight, theme }) =>
        hasHighlight &&
        css`
            color: ${theme.colors.primary_500};
        `}

    @media ${respondAbove.md} {
        justify-content: flex-end;
        padding: 11px 14px;
    }
`

export const DayBadgesWrapper = styled(Box)`
    position: absolute;
    bottom: 10%;
    flex-direction: row;

    @media ${respondAbove.md} {
        right: 35%;
        top: 20%;
        bottom: auto;
    }

    & > * {
        margin-left: 4px;

        &:first-child {
            margin-left: 0;
        }
    }
`

interface DayHighlightBadgeWrapperProps {
    hasCustomBadges?: boolean
}

export const DayHighlightBadgeWrapper = styled(
    Box
)<DayHighlightBadgeWrapperProps>`
    position: absolute;
    bottom: 10%;

    ${({ hasCustomBadges }) =>
        hasCustomBadges &&
        css`
            bottom: auto;
            top: 0;
            margin-top: -3px;
        `}

    @media ${respondAbove.md} {
        right: 35%;
        top: 35%;
        bottom: auto;

        ${({ hasCustomBadges }) =>
            hasCustomBadges &&
            css`
                margin-top: 6px;
            `}
    }

    div {
        margin-top: 2px;

        @media ${respondAbove.md} {
            margin-top: 0;
        }
    }
`

interface NumberProps {
    unlimitedEntryType: string
}

export const Number = styled.div<NumberProps>`
    &:not(.CalendarDay__outside div div) {
        ${({ unlimitedEntryType, theme }) =>
            unlimitedEntryType === 'unlimited' &&
            css`
                color: ${theme.colors.secondary_500};
            `}
        ${({ unlimitedEntryType, theme }) =>
            unlimitedEntryType === 'unlimitedPlus' &&
            css`
                color: ${theme.colors.primary_500};
                ::before {
                    content: url(${badgePlus});
                }
            `}
        ${({ unlimitedEntryType, theme }) =>
            unlimitedEntryType === 'closed' &&
            css`
                color: ${theme.colors.error};
                ::before {
                    content: url(${badgeWarning});
                }
            `}
        ${({ unlimitedEntryType }) =>
            (unlimitedEntryType === 'closed' ||
                unlimitedEntryType === 'unlimitedPlus') &&
            css`
                ::before {
                    position: absolute;
                    transform: translate(-50%, -50%);
                    top: 80%;
                    right: 20%;

                    @media ${respondAbove.xxs} {
                        right: 25%;
                    }
                    @media ${respondAbove.xs} {
                        right: 28%;
                    }
                    @media ${respondAbove.sm} {
                        right: 38%;
                    }
                    @media ${respondAbove.md} {
                        top: 35%;
                        right: 27%;
                    }
                }
            `};
    }
`
